var currency = require( '../global/currency' );

var pricing_table = (function ( $ ) {

	var _init = function () {
		_setup_cards_cycle_switcher();

		currency.refresh_prices_currency(); // Needed to show pages set currency without refresh
	};

	var _setup_cards_cycle_switcher = function() {
		var $cards = $( '#subscription-cards' ),
			$switcher = $( '#pricing-cycle-switcher' );

		$switcher.find( 'a' ).on( 'click', function( e ) {
			e.preventDefault();

			var $link = $( this );

			if ( $link.attr( 'href' ) === '#monthly' ) {
				$cards.find( '.cycle-monthly' ).css( 'display', 'block' );
				$cards.find( '.cycle-annually' ).css( 'display', 'none' );
			} else if ( $link.attr( 'href' ) === '#annually' ) {
				$cards.find( '.cycle-annually' ).css( 'display', 'block' );
				$cards.find( '.cycle-monthly' ).css( 'display', 'none' );
			}

			$switcher.find( '.active' ).removeClass( 'active' );

			$link.addClass( 'active' );
		} );
	}

	if ( $( 'html body' ).is( '.page-template-page-targeted-landing, .page-template-page-choose-plan, .page-template-page-front-page' ) ) {
		$( document ).ready( _init );
	}

	return {};

})( jQuery );

module.exports = pricing_table;